<template>
    <div>
        <el-form class="u-mb-20">
            <el-row :gutter="10" class="u-mt-10 u-mb-20">
                <el-col :xs="24" :sm="10" :md="10">
                    <el-form-item label="Nome do Usuário">
                        <el-input v-model="filtro['name']" @keyup.native.enter="loadingUsuarios"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="10" :md="10">
                    <el-form-item label="Tipo do Usuário">
                        <el-select @change="loadingUsuarios" v-model="filtro['tipo']" clearable>
                            <el-option v-for="(item, i) in $CONSTANTS.TIPO_USER" :key="i" :label="item" :value="i"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="4" :md="4" class="u-text-right">
                    <router-link to="/admin/usuario/cadastro" style="margin-top: 25px; display: inline-block;">
                        <el-button type="primary">NOVO USUÁRIO</el-button>
                    </router-link>
                </el-col>
            </el-row>
        </el-form>
        <div class="container-table">
            <table class="table table-striped">
                <thead>
                    <tr>
                        <th class="hidden-mobile" style="width: 70px;">cod</th>
                        <th>Nome</th>
                        <th>E-mail</th>
                        <th>Tipo</th>
                        <th class="u-text-center">Status</th>
                        <th style="width: 150px;" class="u-text-center">Ação</th>
                    </tr>
                </thead>
                <tbody v-if="statusList">
                    <tr v-for="item in items" :key="item.id">
                        <td class="hidden-mobile">{{ item.id }}</td>
                        <td>{{ item.name | truncate(30, '...') }}</td>
                        <td>{{ (item.email) ? item.email : '-' }}</td>
                        <td>{{ $CONSTANTS.TIPO_USER[item.tipo] }}</td>
                        <td class="u-text-center">
                            
                            <b v-if="item.situacao" style="color: green">ATIVO</b>

                            <b v-if="!item.situacao" style="color: red">INATIVO</b>
                                                    
                        </td>
                        <td class="u-text-center acao"> 
                            <router-link :to="'/admin/usuario/edit/'+ item.id" class="link-icon u-mr-10" style="color: rgba(0, 0, 0, 0.87) !important;">
                                <el-button type="info" title="Editar" icon="el-icon-edit" size="mini" plain></el-button>
                            </router-link>
                        </td>
                    </tr>
                </tbody>
            </table>
            <div v-if="!statusList" class="u-text-center u-mt-25">
                <img src="/public/img/loading-bar.gif" />
            </div>
            <el-row :gutter="10" v-if="statusList">
                <el-col :xs="24" :sm="12" :md="12">
                    <div class="u-text-left u-mt-10">
                        Mostrando {{ paginate.from }} até {{ paginate.to }} de {{ paginate.qtdItens }} registros encontrados.
                    </div>
                </el-col>
                <el-col :xs="24" :sm="12" :md="12" v-if="paginate.qtdItens > 30">
                    <div class="u-text-right">
                            <el-pagination :current-page='paginate.page' class="u-mt-10" :total="paginate.qtdItens" @current-change="getPagePagination" :page-size="30" background layout="prev, pager, next" small></el-pagination>
                        </div>
                </el-col>
            </el-row>
        </div>

    </div>
</template>
<script>

export default {
    data: () => ({
        statusList: false,
        filtro: {
            name: '',
            tipo: ''
        },
        paginate:{ 
            page: 1,
            qtdItens: null,
            from: '',
            to: ''
        },
        items: [ ]
    }),
    mounted () {
      this.loadingUsuarios()
    },
    methods: {
        loadingUsuarios(){

            this.statusList = false;
            this.items = [];

            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/usuario/getAllPaginate?page=` + this.paginate.page, this.filtro, this.$store.getters.getHeaderAuth).then(response => {

                this.items = response.data.data;
                this.paginate.qtdItens = response.data.total;
                this.paginate.from = response.data.from;
                this.paginate.to = response.data.to;
                this.statusList = true;

            }).catch((error) => { this.$store.commit('throwException', error); });

        },
        getPagePagination(page){
          this.paginate.page = page;
          this.loadingUsuarios();
        }
    },
    components:{  }
}
</script>